"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scaleContainingImageUp = exports.scaleContainingImageDown = exports.scaleContainingImage = exports.backgroundColor = exports.ZOOM_UP = exports.ZOOM_DOWN = void 0;
var _theme = require("../../themes/Base/theme");
var easing = _interopRequireWildcard(require("./easing"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
// @TODO - device breakpoints from theme

var ZOOM_DOWN = 1.05;
exports.ZOOM_DOWN = ZOOM_DOWN;
var ZOOM_UP = 1.001;

/**
 * Scale an image within a container to zoom up or down on hover
 *
 * Usage:
 *
 * <div class="larger-wrapper">
 *   <div class="image-container"><img src="cool-image.png" /></div>
 *   <div class="caption">Cool picture</div>
 * </div>
 * .my-container {
 *  ${scaleContainingImage(".larger-wrapper", 1.05, 1.001)}
 * }
 */
exports.ZOOM_UP = ZOOM_UP;
var scaleContainingImage = function scaleContainingImage(ContainerSelector, initialValue, targetedValue) {
  return "\n  overflow: hidden;\n  & > * {\n    /* Don't apply hover effect to mobile safari */\n    html:not(.is-safari) & img {\n      transform: scale3d(".concat(initialValue, ", ").concat(initialValue, ", 1);\n      transition: transform 300ms ").concat(easing.easeOutQuad, " 0s;\n    }\n    html.is-safari & img {\n      @media ").concat(_theme.device.mobileXL, " {\n        transform: scale3d(").concat(initialValue, ", ").concat(initialValue, ", 1);\n        transition: transform 300ms ").concat(easing.easeOutQuad, " 0s;        \n      }\n    }\n\n    ").concat(ContainerSelector, ":hover & img {\n      /* Don't apply hover effect to mobile safari */\n      html:not(.is-safari) & {\n        transform: scale3d(").concat(targetedValue, ", ").concat(targetedValue, ", 1);        \n      }\n      html.is-safari & img {\n        @media ").concat(_theme.device.mobileXL, " {\n          transform: scale3d(").concat(targetedValue, ", ").concat(targetedValue, ", 1);         \n        }\n      }\n    }\n  }\n");
};
/** Easy wrapper to `scaleContainingImage` with predefined values on zooming out */
exports.scaleContainingImage = scaleContainingImage;
var scaleContainingImageDown = function scaleContainingImageDown(ContainerSelector) {
  return scaleContainingImage(ContainerSelector, ZOOM_DOWN, ZOOM_UP);
};

/** Easy wrapper to `scaleContainingImage` with predefined values on zooming in */
exports.scaleContainingImageDown = scaleContainingImageDown;
var scaleContainingImageUp = function scaleContainingImageUp(ContainerSelector) {
  return scaleContainingImage(ContainerSelector, ZOOM_UP, ZOOM_DOWN);
};

/**
 * Helper to apply a background color to an element
 */
exports.scaleContainingImageUp = scaleContainingImageUp;
var backgroundColor = function backgroundColor(color) {
  return "\n  transition: background-color 0.5s ".concat(easing.easeOutCubic, ";\n  &:hover {\n    background-color: ").concat(color, ";\n  }\n");
};
exports.backgroundColor = backgroundColor;